"use client";

import Link from "next/link";
import React, { useMemo } from "react";

import { Text, TextSize, TextWeight } from "../../components";
import type { OrderReturn } from "../../types/orderReturn.type";

type OrderReturnCardProps = {
  orderReturn: OrderReturn;
};

const OrderReturnCard: React.FC<OrderReturnCardProps> = ({ orderReturn }) => {
  // Memoize formatted values
  const formattedDate = useMemo(
    () => new Date(orderReturn.dateAdd).toLocaleDateString("pl-PL"),
    [orderReturn.dateAdd],
  );

  const formattedDateUpdate = useMemo(
    () => new Date(orderReturn.dateUpd).toLocaleDateString("pl-PL"),
    [orderReturn.dateUpd],
  );

  const detailsUrl = useMemo(
    () => `/zwroty-produktow/${orderReturn.idOrderReturn}`,
    [orderReturn.idOrderReturn],
  );

  return (
    <Link href={detailsUrl}>
      <div className="bg-white border border-gray-200 hover:shadow-sm transition-all duration-200">
        <div className="p-6 cursor-pointer">
          <div className="flex justify-between items-center">
            <div className="flex-1">
              <div className="grid grid-cols-2 lg:grid-cols-5 gap-1 md:gap-4">
                <div>
                  <Text text="Nr zamówienia:" fontSize={TextSize.S} />
                  <Text
                    text={orderReturn.idOrder}
                    fontSize={TextSize.L}
                    weight={TextWeight.SEMIBOLD}
                  />
                </div>

                <div>
                  <Text text="Nr zwrotu:" fontSize={TextSize.S} />
                  <Text
                    text={orderReturn.idOrderReturn}
                    fontSize={TextSize.L}
                    weight={TextWeight.SEMIBOLD}
                  />
                </div>

                <div>
                  <Text text="Status zwrotu:" fontSize={TextSize.S} />
                  <Text
                    text={orderReturn.stateName}
                    fontSize={TextSize.L}
                    weight={TextWeight.SEMIBOLD}
                  />
                </div>

                <div>
                  <Text text="Data zwrotu:" fontSize={TextSize.S} />
                  <Text
                    text={formattedDate}
                    fontSize={TextSize.L}
                    weight={TextWeight.SEMIBOLD}
                  />
                </div>

                <div>
                  <Text
                    text="Data ostatniej aktualizacji:"
                    fontSize={TextSize.S}
                  />
                  <Text
                    text={formattedDateUpdate}
                    fontSize={TextSize.L}
                    weight={TextWeight.SEMIBOLD}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default OrderReturnCard;
